'use client';
import React, { useEffect } from 'react';
import { pushToDataLayer } from './gtmUtils';

type Props = {
  name: string;
  data: any;
};

function GtmClient({ name, data }: Props) {
  useEffect(() => {
    pushToDataLayer(name, data);
  }, [name, data]);
  return <></>;
}

export default GtmClient;
